"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var browser = _interopRequireWildcard(require("./browser"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  border: 0,
  outline: 0
});

var _default = function _default(_ref) {
  var ariaLabel = _ref['aria-label'],
      blurFocusOnClick = _ref.blurFocusOnClick,
      children = _ref.children,
      className = _ref.className,
      mode = _ref.mode;

  var _useContext = (0, _react.useContext)(_Context.default),
      dir = _useContext.dir,
      scrollBarPercentage = _useContext.scrollBarPercentage,
      scrollOneLeft = _useContext.scrollOneLeft,
      scrollOneRight = _useContext.scrollOneRight;

  var ref = (0, _react.useRef)();
  var left = mode === 'left';
  var handleClick = (0, _react.useCallback)(function () {
    left ? scrollOneLeft() : scrollOneRight();
    blurFocusOnClick && ref.current.blur();
  }, [blurFocusOnClick, mode, ref, scrollOneLeft, scrollOneRight]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    var key = event.key;

    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      left ? scrollOneLeft() : scrollOneRight();
    }
  }, [mode, ref, scrollOneLeft, scrollOneRight]);
  var hide;

  if (dir === 'rtl' && !browser.chrome) {
    if (left) {
      hide = scrollBarPercentage === '100%' || scrollBarPercentage === '-100%';
    } else {
      hide = scrollBarPercentage === '0%';
    }
  } else {
    if (left) {
      hide = scrollBarPercentage === '0%';
    } else {
      hide = scrollBarPercentage === '100%';
    }
  }

  return _react.default.createElement("button", {
    "aria-label": ariaLabel || (left ? 'left' : 'right'),
    className: (0, _classnames.default)(ROOT_CSS + '', className, {
      hide: hide
    }),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    type: "button",
    ref: ref
  }, _react.default.createElement("div", {
    className: "slider"
  }, children));
};

exports.default = _default;